export enum FONTS {
  primary = "'Helvetica Neue', Baskervville, serif, Arial, Helvetica, sans-serif"
}
